<template>
  <div class="cover-option-component">
    <div
      v-if="!mobile && optionType == 'image'"
      class="card-box p-5"
      :class="{ selected: form.cover_view_type === 'image' }"
    >
      <b-form-checkbox
        v-if="!isModule"
        id="cover-view-type-image"
        class=""
        v-model="form.cover_view_type"
        value="image"
      >
        Imagem
      </b-form-checkbox>
      <div class="row p-5 mb-5 mt-6 ml-0">
        <input-image
          v-model="form.cover"
          id="image-cover"
          title="Capa horizontal"
          description="Esta imagem será exibida no topo."
          class="col-md-6"
          dimensions="2160x740px"
        />
        <image-cover-mockup :image="form.cover" class="pt-6 pt-md-0 col-md-6" />
      </div>
    </div>

    <div
      v-else-if="!mobile && optionType == 'video' && !isModule"
      class="card-box p-5 my-6"
      :class="{ selected: form.cover_view_type === 'video' }"
    >
      <b-form-checkbox
        id="cover-view-type-video"
        class="flex-fill fs-14"
        v-model="form.cover_view_type"
        value="video"
      >
        Vídeo
      </b-form-checkbox>
      <div class="row mb-5 mt-6 ml-0">
        <div class="col-md-6">
          <form-group
            v-model="form.link_video"
            :errors="errors.link_video"
            id="link_video"
            placeholder="Insira  a URL do vídeo"
            label="Link da mídia"
            class="pb-0"
          />
          <small class="small-text">
            Seus arquivos precisam estar hospedados em um serviço, como YouTube,
            Vimeo, Pandavideo, etc.
          </small>
        </div>
        <background-video-mockup
          :image="link_video_placeholder"
          class="col-md-6"
        />
      </div>
    </div>

    <!-- <div
      v-else-if="!mobile && optionType == 'image_and_video'"
      class="card-box p-5"
      :class="{ selected: form.cover_view_type === 'image_and_video' }"
    >
      <b-form-checkbox
        id="cover-view-type-image_and_video"
        class="flex-fill fs-14"
        v-model="form.cover_view_type"
        value="image_and_video"
      >
        Imagem e vídeo
      </b-form-checkbox>
      <div class="row p-5 mb-5 mt-6 ml-0">
        <input-image
          v-model="form.cover"
          id="image-video-cover"
          title="Capa horizontal"
          description=Esta imagem será exibida no topo."
          class="col-md-6"
          dimensions="1440x416px"
        />
        <video-miniature-mockup
          :image="form.cover"
          :video="link_video_placeholder"
          class="col-md-6"
        />
      </div>

      <form-group
        v-model="form.link_video"
        :errors="errors.link_video"
        id="link_video"
        placeholder="Insira  a URL do vídeo"
        label="Link da mídia"
        class="pb-0"
      />
      <small class="small-text text-secondary">
        Seus arquivos precisam estar hospedados em um serviço, como YouTube,
        Vimeo, SoundCloud, etc.
      </small>
    </div> -->

    <div
      v-else-if="mobile && optionType == 'image'"
      class="card-box p-5"
      :class="{ selected: form.cover_view_type_mobile === 'image' }"
    >
      <!-- <b-form-checkbox
        id="cover-view-type-image-mobile"
        class="flex-fill fs-14"
        v-model="form.cover_view_type_mobile"
        value="image"
      >
        Imagem
      </b-form-checkbox> -->
      <div class="row p-5 mb-5 mt-6 ml-0">
        <input-image
          v-model="form.cover_mobile"
          id="image-mobile-cover"
          title="Capa Mobile"
          description="Esta imagem será exibida no topo."
          class="col-md-6"
          dimensions="560x740px"
        />
        <image-cover-mockup
          mobile
          :image="form.cover_mobile"
          class="pt-6 pt-md-0 col-md-6"
        />
      </div>
    </div>
    <!-- <div
      v-else-if="mobile && optionType == 'video'"
      class="card-box p-5 mb-6"
      :class="{ selected: form.cover_view_type_mobile === 'video' }"
    >
      <b-form-checkbox
        id="cover-view-type-video-mobile"
        class="flex-fill fs-14"
        v-model="form.cover_view_type_mobile"
        value="video"
      >
        Vídeo
      </b-form-checkbox>
      <div class="row mb-5 mt-6 ml-0">
        <div class="col-md-6">
          <form-group
            v-model="form.link_video_mobile"
            :errors="errors.link_video_mobile"
            id="link_video"
            placeholder="Insira  a URL do vídeo"
            label="Link da mídia"
            class="pb-0"
          />
          <small class="small-text">
            Seus arquivos precisam estar hospedados em um serviço, como YouTube,
            Vimeo, Pandavideo, etc.
          </small>
        </div>
        <background-video-mockup
          mobile
          :image="link_video_placeholder_mobile"
          class="col-md-6"
        />
      </div>
    </div> -->

    <div class="card-box p-5 mb-9" v-else-if="optionType === 'club'">
      <div class="row p-5 mb-5 mt-6 ml-0">
        <input-image
          v-model="form.cover_blitz_club"
          id="image-club-cover"
          title="Capa quadrada"
          description="Imagem de apresentação do produto no B.Club."
          class="col-md-6"
          dimensions="320x320px"
        />
        <club-cover-mockup
          mobile
          :image="form.cover_blitz_club"
          class="pt-6 pt-md-0 col-md-6"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BackgroundVideoMockup from "@/components/product/member-area/setup/BackgroundVideoMockup.vue";
import ClubCoverMockup from "@/components/product/member-area/setup/ClubCoverMockup.vue";
import ImageCoverMockup from "@/components/product/member-area/setup/ImageCoverMockup.vue";
import { vimeoParser, youtubeParser } from "@/functions/helpers";
export default {
  components: {
    ImageCoverMockup,
    ClubCoverMockup,
    BackgroundVideoMockup,
    //VideoMiniatureMockup,
    ImageCoverMockup
  },
  props: {
    optionType: {
      type: String,
      default: "image",
      validator: value =>
        ["image", "video", "image_and_video", "club"].includes(value)
    },
    mobile: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      link_video_placeholder: "",
      link_video_placeholder_mobile: ""
    };
  },
  mounted() {
    if (this.form.link_video_mobile) {
      this.handlePlaceholderUrl(this.form.link_video_mobile, "_mobile");
    }
    if (this.form.link_video) {
      this.handlePlaceholderUrl(this.form.link_video);
    }
  },
  watch: {
    "form.link_video"(link) {
      this.handlePlaceholderUrl(link);
    },
    "form.link_video_mobile"(link) {
      this.handlePlaceholderUrl(link, "_mobile");
    }
  },
  methods: {
    async handlePlaceholderUrl(url = "", type = "") {
      let placeholder_url = "";

      if (url.includes("vimeo")) {
        const resp = await fetch(
          `https://vimeo.com/api/v2/video/${vimeoParser(url)}.json`
        );
        const data = await resp.json();
        placeholder_url = data[0].thumbnail_large;
      }

      if (url.includes("youtu")) {
        placeholder_url = `https://img.youtube.com/vi/${youtubeParser(
          url
        )}/maxresdefault.jpg`;
      }

      this[`link_video_placeholder${type}`] = placeholder_url;
    }
  },
  computed: {
    isModule() {
      return this.$route.name.includes("module");
    }
  }
};
</script>
<style lang="scss" scoped>
.cover-option-component {
  .card-box {
    height: fit-content;
  }

  small {
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
  }
}
</style>
